export var TypeActionScene;
(function (TypeActionScene) {
    TypeActionScene["Swap"] = "Scene > Swap";
    TypeActionScene["RequestSwap"] = "Scene > RequestSwap";
})(TypeActionScene || (TypeActionScene = {}));
/**
 * Don't use this method directly. It's only used by actionRequestSceneSwap handler.
 * Use actionRequestSceneSwap instead.
 * @param sceneId
 */
export var actionSceneSwap = function (sceneId) { return ({
    sceneId: sceneId,
    type: TypeActionScene.Swap,
}); };
export var actionRequestSceneSwap = function (sceneId) { return ({
    sceneId: sceneId,
    type: TypeActionScene.RequestSwap,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/actionScenes.ts
// module id = 150
// module chunks = 3